module.exports = __webpack_public_path__ + "1273e3b5c4035c8413da1c59e3b615f5.mp4";